import { useEffect, useRef } from 'react';

export default function useOutsideClick(callback, listenCapturing = true) {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Do nothing if clicking inside the ref element or its children
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    // Use mousedown instead of click → feels more responsive for menus
    document.addEventListener('mousedown', handleClickOutside, listenCapturing);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, listenCapturing);
    };
  }, [callback, listenCapturing]);

  return ref;
}